import { usePatientProfile } from 'apps/wrapper/src/hooks/use-patient-profile';
import { FC, useMemo } from 'react';
import { AllCommunicationSection, CommunicationSubSection, Section, SelectAllSection, Separator } from './comm-preferences.styles';


type CommPreferencesDirectEmailViewProps = {
  setChange: (key: string, value: any) => void;
  changes: any;
};

export const CommPreferencesDirectEmailView: FC<CommPreferencesDirectEmailViewProps> = ({ setChange, changes }) => {
  const { patientPreferences } = usePatientProfile();

  const localPreferences = useMemo(
    () => changes.updateLocalPreferences || patientPreferences,
    [patientPreferences, changes]
  );

  const updateLocalPreferences = (state: Partial<typeof patientPreferences>) => {
    const newState = { ...patientPreferences, ...changes.updateLocalPreferences, ...state };

    setChange('updateLocalPreferences', newState);
  };

  return (
    <div>
      <Section>
        <SelectAllSection>
          <AllCommunicationSection
            text="All Direct Mail"
            isChecked={
              localPreferences.dmAppointmentReminders &&
              localPreferences.dmBirthdayAndHolidayCards &&
              localPreferences.dmExpiringInsuranceReminder &&
              localPreferences.dmPatientReactivation &&
              localPreferences.dmRecalls &&
              localPreferences.dmSpecialsAndNewsletters &&
              localPreferences.dmTreatmentPlanFollowUps
            }
            onChange={(value) =>
              updateLocalPreferences({
                dmAppointmentReminders: value,
                dmBirthdayAndHolidayCards: value,
                dmExpiringInsuranceReminder: value,
                dmPatientReactivation: value,
                dmRecalls: value,
                dmSpecialsAndNewsletters: value,
                dmTreatmentPlanFollowUps: value
              })
            }
          />
        </SelectAllSection>
        <Separator>Essential Communications</Separator>
        <CommunicationSubSection
          text="Appointment Reminders"
          isChecked={localPreferences.dmAppointmentReminders}
          onChange={(value) => updateLocalPreferences({ dmAppointmentReminders: value })}
        />
        <CommunicationSubSection
          text="Patient Reactivation"
          isChecked={localPreferences.dmPatientReactivation}
          onChange={(value) => updateLocalPreferences({ dmPatientReactivation: value })}
        />
        <CommunicationSubSection
          text="Recalls"
          isChecked={localPreferences.dmRecalls}
          onChange={(value) => updateLocalPreferences({ dmRecalls: value })}
        />
        <Separator>Marketing & Promotional</Separator>
        <CommunicationSubSection
          text="Treatment Plan Follow-ups"
          isChecked={localPreferences.dmTreatmentPlanFollowUps}
          onChange={(value) => updateLocalPreferences({ dmTreatmentPlanFollowUps: value })}
        />
        <CommunicationSubSection
          text="Birthday/Holiday Cards"
          isChecked={localPreferences.dmBirthdayAndHolidayCards}
          onChange={(value) => updateLocalPreferences({ dmBirthdayAndHolidayCards: value })}
        />

        <CommunicationSubSection
          text="Specials & Newsletters"
          isChecked={localPreferences.dmSpecialsAndNewsletters}
          onChange={(value) => updateLocalPreferences({ dmSpecialsAndNewsletters: value })}
        />
        <CommunicationSubSection
          text="Expiring Insurance Reminder"
          isChecked={localPreferences.dmExpiringInsuranceReminder}
          onChange={(value) => updateLocalPreferences({ dmExpiringInsuranceReminder: value })}
        />
      </Section>
    </div>
  );
};
